/*
 * Filter memory for /tasks (My day vs All tasks) and /event-interest (Enquiries:
 * Demand, Submissions, Proposals, Report leads).
 *
 * Only URL-backed keys can be listed here. Never remembered:
 * - /tasks: the page number is component state, not the URL.
 * - /event-interest: `search`, `page`, the submission Live/Archived/All view and
 *   the column funnels (Region, Assigned) are component state; the Proposals and
 *   Report leads panels read no search params at all.
 * - /event-interest `companyId`: a one-shot arrival from a company record's own
 *   panel (a badge, no control), so restoring it would narrow a later visit by a
 *   company nobody picked.
 * - /event-interest `formRegion`: read for the active-filter count and cleared on
 *   tab switch, but nothing writes it to the URL (the Region funnel is local
 *   state), so restoring a stale one would count a filter that is never sent.
 */
import type { FilterMemoryRule } from './types';

export const FILTER_MEMORY_TASKS_ENQUIRIES: readonly FilterMemoryRule[] = [
  {
    path: '/tasks',
    keep: [
      'view', // My day (key absent) vs All tasks ('list'); also inferred from any list-only key
      'horizon', // My day look-ahead in days, 1-30 (default 7)
      'status', // All tasks status: open (default) | done | cancelled | closed | all
      'kind', // All tasks kind filter
      'unattached', // All tasks: '1' = only tasks attached to no record
      'who', // All tasks assignee: me (default) | everyone | user id (audit grant only)
      'sort', // All tasks sort column (paired with order)
      'order', // All tasks sort direction (paired with sort)
    ],
  },
  {
    path: '/event-interest',
    keep: [
      'tab', // Demand (key absent) | submissions | proposals | reports
      'projectId', // Submissions festival filter (Festival combobox or the Demand table's "See who")
      'approvalStatus', // Submissions company approval-status filter
    ],
  },
];
